@let fieldData = field();
@let formControl = control();

@if (formControl) {
  <div class="mb-6 relative">
    <tui-textfield
      xHyphenedStringTuiDateTransformer
      class="workflow-field"
      tuiTextfieldSize="l"
      [tuiTextfieldCleaner]="true"
    >
      <label tuiLabel>
        <span
          [class.font-extrabold!]="fieldData.isHighlighted"
          class="x-text-wf-title x-font-body-3-important"
        >
          {{ fieldData.title }}
        </span>
        @if (fieldData.validation?.isRequired) {
          <span class="font-extrabold x-font-body-3-important">*</span>
        }
      </label>
      <input tuiInputDate [formControl]="formControl" />
      <tui-calendar *tuiDropdown />
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText" />
      }
    </tui-textfield>

    @if (formControl.invalid && (formControl.dirty || formControl.touched)) {
      <div class="x-text-wf-error x-font-body-5 mt-1 absolute">
        @if (formControl.hasError('required')) {
          <span>Обязательное поле</span>
        }
        @if (formControl.hasError('minDate')) {
          <span
            >Минимальная дата: {{ formControl.getError('minDate').min }}</span
          >
        }
        @if (formControl.hasError('maxDate')) {
          <span
            >Максимальная дата: {{ formControl.getError('maxDate').max }}</span
          >
        }
        @if (formControl.hasError('customError')) {
          <span>Ошибка валидации</span>
        }
      </div>
    }
  </div>
}
